import React, { useState } from 'react';
import { riskApi } from '../../utils/riskApi';
import { Modal } from '../review/reviewUi';

/**
 * Take a baseline: a name and an optional note. The server re-reads Orcanos in full first —
 * a baseline is something a team signs off against, never a snapshot of a cache.
 */
export default function TakeBaselineModal({ panel, onClose, onTaken }) {
  const [name, setName] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    if (!name.trim()) { setError('Give the baseline a name, e.g. “Design freeze 2”.'); return; }
    setBusy(true);
    setError('');
    try {
      const r = await riskApi.takeBaseline(panel.id, { name: name.trim(), note: note.trim() });
      onTaken(r.baseline);
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };

  return (
    <Modal
      title="Take baseline"
      subtitle={`A read-only snapshot of “${panel.name}”: every risk, score, trace and control status, and the FMEA settings used.`}
      onClose={onClose}
      footer={(
        <>
          <button type="button" className="drv-btn drv-btn--lg" onClick={onClose}>Cancel</button>
          <button type="button" className="drv-btn drv-btn--primary drv-btn--lg" onClick={save} disabled={busy}>
            {busy ? 'Reading Orcanos…' : 'Take baseline'}
          </button>
        </>
      )}
    >
      <label className="drv-field">
        <span className="drv-lbl">Name</span>
        <input className="drv-input" value={name} onChange={(e) => { setName(e.target.value); setError(''); }}
          placeholder="e.g. Design freeze 2 · 510(k) submission" maxLength={120} autoFocus />
      </label>
      <label className="drv-field">
        <span className="drv-lbl">Note <span>— optional</span></span>
        <textarea className="drv-input rsk-textarea" rows={3} value={note} onChange={(e) => setNote(e.target.value)}
          placeholder="e.g. Design review DR-3, before the verification campaign" maxLength={1000} />
      </label>
      <p className="drv-small" style={{ margin: 0 }}>
        Baselines can be archived but never edited or deleted. Each one carries a SHA-256 of its content.
      </p>
      {error && <div className="drv-error" role="alert">{error}</div>}
    </Modal>
  );
}
